import { api, ApiError } from './baseApi'
import type { LoginRequest, LoginResponse, LoginVerifyRequest, LoginVerifyResponse } from '@/types/auth.types'
import { AuthErrorCode } from '@/types/auth.types'

export async function loginApi(request: LoginRequest): Promise<LoginResponse> {
  try {
    const response = await api.post<LoginResponse>('/auth/affiliate/login', request)
    return response.data
  } catch (error) {
    if (error instanceof ApiError) {
      try {
        const apiError = error.data as LoginResponse
        return {
          success: apiError?.success ?? false,
          requiresHumanCaptcha: apiError?.requiresHumanCaptcha ?? false,
          humanCaptchaSiteKey: apiError?.humanCaptchaSiteKey,
          errorMessage: apiError?.errorMessage,
          errorCode: apiError?.errorCode,
        }
      } catch {
        // Failed to parse error response
      }
    }
    return {
      success: false,
      requiresHumanCaptcha: false,
      errorMessage: 'An unexpected error occurred. Please try again.',
      errorCode: AuthErrorCode.GetUserFailed,
    }
  }
}

export async function verifyApi(request: LoginVerifyRequest): Promise<LoginVerifyResponse> {
  try {
    const response = await api.post<LoginVerifyResponse>('/auth/affiliate/loginVerify', request)
    return response.data
  } catch (error) {
    if (error instanceof ApiError) {
      try {
        const apiError = error.data as LoginVerifyResponse
        return {
          success: apiError?.success ?? false,
          token: '',
          requiresHumanCaptcha: apiError?.requiresHumanCaptcha ?? false,
          humanCaptchaSiteKey: apiError?.humanCaptchaSiteKey,
          errorMessage: apiError?.errorMessage,
          errorCode: apiError?.errorCode,
        }
      } catch {
        // Failed to parse error response
      }
    }
    return {
      success: false,
      token: '',
      requiresHumanCaptcha: false,
      errorMessage: 'An unexpected error occurred. Please try again.',
      errorCode: AuthErrorCode.GetUserFailed,
    }
  }
}
